// Service to manage lesson completion state
// This is a simple implementation using localStorage
// In a real application, this would interact with a backend API

// Key for storing completed lessons in localStorage
const COMPLETED_LESSONS_KEY = 'completed_lessons';

/**
 * Get all completed lesson IDs
 * @returns {Array} Array of completed lesson IDs
 */
export const getCompletedLessons = () => {
  try {
    const storedLessons = localStorage.getItem(COMPLETED_LESSONS_KEY);
    return storedLessons ? JSON.parse(storedLessons) : [];
  } catch (error) {
    console.error('Error retrieving completed lessons:', error);
    return [];
  }
};

/**
 * Mark a lesson as completed
 * @param {string} lessonId - ID of the lesson to mark as completed
 * @returns {Array} Updated array of completed lesson IDs
 */
export const markLessonAsCompleted = (lessonId) => {
  try {
    const completedLessons = getCompletedLessons();
    
    // Only add the lesson if it's not already marked as completed
    if (!completedLessons.includes(lessonId)) {
      const updatedLessons = [...completedLessons, lessonId];
      localStorage.setItem(COMPLETED_LESSONS_KEY, JSON.stringify(updatedLessons));
      return updatedLessons;
    }
    
    return completedLessons;
  } catch (error) {
    console.error('Error marking lesson as completed:', error);
    return getCompletedLessons();
  }
};

/**
 * Check if a lesson is completed
 * @param {string} lessonId - ID of the lesson to check
 * @returns {boolean} True if the lesson is completed, false otherwise
 */
export const isLessonCompleted = (lessonId) => {
  const completedLessons = getCompletedLessons();
  return completedLessons.includes(lessonId);
};
